/**
 * CoverageHealthIcon — Mi6 custom glyph: shield with heartbeat line
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function CoverageHealthIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Shield outline */}
      <path
        d="M40 12 L62 20 L62 40 C62 54 40 68 40 68 C40 68 18 54 18 40 L18 20 Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Heartbeat / ECG line inside shield */}
      <polyline
        points="24,40 30,40 33,33 37,48 41,36 45,44 48,40 56,40"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
